module.exports = __webpack_public_path__ + "static/media/table1.b1f95b6c.jpg";